import type { SentFromEmailCondition as SentFromEmailConditionType } from "@redotech/redo-flows-common/rules/schemas";
import { useTranslation } from "@redotech/redo-i18n";
import { RedoTagInputField } from "@redotech/redo-web/arbiter-components/input/redo-tag-input-field";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useState } from "react";
import { commitPendingTagInput } from "../../commit-pending-tag-input";

export const SentFromEmailCondition = memo(function SentFromEmailCondition({
  condition,
  onChange,
}: {
  condition: SentFromEmailConditionType;
  onChange: (updated: SentFromEmailConditionType) => void;
}) {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState("");

  const commitPendingInput = () => {
    const emails = commitPendingTagInput(condition.emails || [], inputValue);
    if (!emails) {
      return;
    }
    onChange({ ...condition, emails });
    setInputValue("");
  };

  return (
    <Flex dir="column" gap="md" w="full">
      <RedoTagInputField
        inputValue={inputValue}
        label={t("Sender email address(es)")}
        onBlur={commitPendingInput}
        placeholder={t("Enter email addresses")}
        setInputValue={setInputValue}
        setTags={(emails) => {
          const uniqueEmails = Array.from(new Set(emails));
          onChange({ ...condition, emails: uniqueEmails });
        }}
        state="default"
        tags={(condition.emails || []).map((email) => ({ text: email }))}
      />
    </Flex>
  );
});
